import { Theme } from '@cambridgeassessment/cambridge-ui';
import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  chip: {
    marginRight: 8,
    marginBottom: 8,
  },
  modalTitle: {
    '& > h5': {
      wordBreak: 'break-all',
      maxWidth: '90%',
    },
    [theme.breakpoints.up('sm')]: {
      minWidth: 444,
    },
    [theme.breakpoints.down('xs')]: {
      '& > h5': {
        width: '90%',
      },
    },
  },
}));
